import {Component, OnInit, ViewChild} from '@angular/core';
import {WizardComponent} from '../wizard/wizard.component';
import {VehicleBrand} from '../../../domain/core/vehicle-brand.model';
import {ActivatedRoute, Router} from '@angular/router';
import {LegalEntity} from '../../../domain/core/legal-entity.model';
import {Country} from '../../../domain/core/country.model';
import {environment} from '../../../../environments/environment';
import {AppState} from '../../../shared/utils/AppState';
import {plainToInstance} from 'class-transformer';
import {WizardType} from '../wizard/wizard-type.enum';
import {EweByMailRequest} from '../../../domain/data/ewe-by-mail-request';
import {CustomerWizardResponse} from '../../../domain/data/customer-wizard-response.data';
import {WizardService} from '../../../shared/services/wizard.service';
import {LoadingSpinnerComponent} from '../../../shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-ewe-by-mail',
  imports: [
    WizardComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './ewe-by-mail.component.html'
})
export class EweByMailComponent implements OnInit {
  brand: VehicleBrand;
  legalEntity = LegalEntity.ToyotaGermany;
  verificationToken: string;
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');
  customerWizardResponse: CustomerWizardResponse;
  eweByMailRequest: EweByMailRequest;
  loadingData = false;

  @ViewChild(WizardComponent) wizardComponent: WizardComponent;

  protected readonly WizardType = WizardType;
  protected readonly console = console;

  constructor(
    private wizardService: WizardService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadingData = true;
    this.route.params.subscribe(params => {
      this.setBrand(params['brand']);
      this.verificationToken = params['verificationToken'];

      if (this.verificationToken) {
        // data for the email wizard
        this.wizardService
          .getCustomerMailWizardData(this.brand.name.toLowerCase(), this.verificationToken)
          .subscribe({
            next: (response: any) => {
              this.customerWizardResponse = plainToInstance(CustomerWizardResponse, response);
              this.loadingData = false;
            },
            error: (error: any) => {
              console.log('error by wizard data', error);
              this.redirectToErrorPage();
            }
          });
      } else {
        // data for the click wizard
        this.wizardService
          .getCustomerWizardData(this.brand.name.toLowerCase())
          .subscribe({
            next: (response: any) => {
              this.customerWizardResponse = plainToInstance(CustomerWizardResponse, response);
              this.loadingData = false;
            },
            error: (error: any) => {
              console.log('error by wizard data', error);
              this.redirectToErrorPage();
            }
          });
      }
    });
    this.eweByMailRequest = new EweByMailRequest();
  }

  setBrand(brand: string) {
    this.brand = new VehicleBrand(brand);
    this.legalEntity = LegalEntity.from(VehicleBrand.from(brand), Country.from(environment.country))
    AppState.shared.setLegalEntity(this.legalEntity)
    this.favIcon.href = '/assets/images/' + this.brand.favicon;
  }

  redirectToErrorPage() {
    this.router.navigate(['error']);
  }

  onStepAccepted(event: { step: number }) {
    switch (event.step) {
      case 2:
        this.eweByMailRequest.communication = true;
        this.wizardComponent.nextStep();
        break;
      case 3:
        this.eweByMailRequest.profiling = true;
        this.wizardComponent.nextStep();
        break;
      case 4:
        this.eweByMailRequest.dataSharing = true;
        this.wizardComponent.nextStep();
        break;
      case 5:
        this.eweByMailRequest.sendSummaryMail = true;
        this.confirmCustomerConsent();
        break;
    }
  }

  onStepSkipped(event: { step: number }) {
    switch (event.step) {
      case 2:
        this.eweByMailRequest.communication = null;
        this.wizardComponent.nextStep();
        break;
      case 3:
        this.eweByMailRequest.profiling = null;
        this.wizardComponent.nextStep();
        break;
      case 4:
        this.eweByMailRequest.dataSharing = null;
        this.checkAllStepsSkipped();
        break;
      case 5:
        this.eweByMailRequest.sendSummaryMail = false;
        this.confirmCustomerConsent();
        break;
    }
  }

  checkAllStepsSkipped() {
    if (this.eweByMailRequest.communication === null &&
      this.eweByMailRequest.profiling === null &&
      this.eweByMailRequest.dataSharing === null) {
      this.wizardComponent.skipAllInProgress = true;
      this.eweByMailRequest.sendSummaryMail = true;
      this.wizardComponent.noConfirmations = true;
      this.confirmCustomerConsent();
    } else {
      this.wizardComponent.nextStep();
    }
  }

  confirmCustomerConsent() {
    if (this.verificationToken) {
      // email wizard
      this.wizardService
        .confirmCustomerConsentFromMailWizard(this.legalEntity.vehicleBrand, this.verificationToken, this.eweByMailRequest)
        .subscribe({
          next: (success: any) => {
            this.wizardComponent.skipAllInProgress = false;
            this.wizardComponent.confirmWithMailInProgress = false;
            this.wizardComponent.confirmWithoutMailInProgress = false;
            this.wizardComponent.goToTheLastStep();
          },
          error: (error: any) => {
            console.log('error by consent confirmation', error);
            this.redirectToErrorPage();
          }
        });
    } else {
      // click wizard
      this.wizardService
        .confirmCustomerConsentFromWizard(this.legalEntity.vehicleBrand, this.eweByMailRequest)
        .subscribe({
          next: (success: any) => {
            this.wizardComponent.skipAllInProgress = false;
            this.wizardComponent.confirmWithMailInProgress = false;
            this.wizardComponent.confirmWithoutMailInProgress = false;
            this.wizardComponent.goToTheLastStep();
          },
          error: (error: any) => {
            console.log('error by consent confirmation', error);
            this.redirectToErrorPage();
          }
        });
    }
  }
}
